import Context from "../../context/Context";
import * as three11Util from "./three11Util";
import * as val from "../../util/val";

let COUNTER = 0;


export function actionMatches(action,source,subType) {
  if (!action || !source) return false;
  const categories = action.categories;
  const layers = action.layers;
  let sourceName = source.name, matches = false;
  if (source.fromCategoriesTable) {
    if (categories.length === 1 && categories[0] === "*") {
      matches = true;
    } else if (categories.indexOf(sourceName) !== -1) {
      matches = true;
    } else if (layers.indexOf(sourceName) !== -1) { // TODO?
      matches = true;
    // } else if (layers.length === 1 && layers[0] === "*") { // TODO?
    //   matches = true;
    } else if (subType) {
      if (categories.indexOf(subType.name) !== -1) {
        matches = true;
      }
    }
  } else {
    if (layers.length === 1 && layers[0] === "*") {
      matches = true;
    } else if (layers.indexOf(sourceName) !== -1) {
      matches = true;
    // } else if (categories.indexOf(sourceName) !== -1) { // TODO?
    //   matches = true;
    }
  }
  return matches;
}

function actionMatchesItem(action,item,considerSubTypes) {
  const source = item && item.getSource();
  if (!action || !source) return false;
  let subType;
  if (considerSubTypes && source.subTypesByValue) {
    let st = item.getSubType();
    if (source.subTypesByValue.hasOwnProperty(st)) {
      subType = source.subTypesByValue[st];
    }
  }
  return actionMatches(action,source,subType);
}

export function checkActions(actions) {
  if (Array.isArray(actions)) {
    actions.forEach(action => {
      if (typeof action.label !== "string") action.label = null;
      if (typeof action.url !== "string") action.url = null;
      if (!Array.isArray(action.layers)) action.layers = [];
      if (!Array.isArray(action.categories)) action.categories = [];
    });
  }
}

export function cloneActions(actionsToClone) {
  const actions = [];
  actionsToClone.forEach(action => {
    action = Object.assign({},action);
    if (Array.isArray(action.layers)) {
      action.layers = action.layers.slice()
    } else {
      action.layers = []
    }
    if (Array.isArray(action.categories)) {
      action.categories = action.categories.slice()
    } else {
      action.categories = []
    }
    actions.push(action);
  });
  return actions;
}

function generateUrl(action,item,urlInfo) {
  const promise = new Promise((resolve,reject) => {
    const source = item && item.getSource();
    const searchResult = item && item.getSearchResult();
    const feature = searchResult && searchResult.feature;
    const actionUrl = val.trim(action.url);
    three11Util.generate311Url(actionUrl,source,feature).then(url => {
      if (val.isNonEmptyStr(url,true)) {
        urlInfo.url = url.trim();
      }
      resolve();
    }).catch(ex => {
      console.warn("Error generating app launch url for",action);
      console.error(ex);
      resolve();
    });
  });
  return promise;
}

export function generateUrls(item) {
  const promise = new Promise((resolve,reject) => {
    try {
      const appLaunch = Context.instance.config.appLaunch;

      /* A few test cases */
      // appLaunch.actions = [
      //   {"label":"JSAPI","url":"https://developers.arcgis.com/javascript/index.html","layers":["*"],"categories":[]},
      //   // {"label":"Test1","url":null,"layers":["*"],"categories":[]},
      //   // {"label":"Test2","url":"","layers":["*"],"categories":[]},
      //   // {"label":null,"url":"https://www.esri.com","layers":["*"],"categories":[]},
      //   // {"label":"","url":"https://www.google.com","layers":["*"],"categories":[]},
      //   // {"label":"Test5","url":"https://www.google.com","layers":[],"categories":[]},
      //   // {"label":"Test6","url":"https://www.google.com","layers":[],"categories":["*"]},
      //   {"label":"Esri","url":"https://www.esri.com","layers":["*"],"categories":[]}
      // ];
      // for (let i=1;i<20;i++) {
      //   appLaunch.actions.push({"label":"T"+i,"url":"https://www.google.com","layers":["*"],"categories":[""]})
      // }
      // appLaunch.actions = [
      //   {"label":"Computer Lab","url":"https://www.esri.com","layers":[],"categories":["Computer Lab"]}
      // ];

      const actions = appLaunch.actions;
      const list = [], promises = [];
      actions.forEach(action => {
        let matches = actionMatchesItem(action,item,true);
        if (matches) {
          let urlInfo = {
            key: nextId(),
            label: action.label,
            url: null
          };
          if (val.isNonEmptyStr(action.url)) {
            list.push(urlInfo);
            promises.push(generateUrl(action,item,urlInfo));
          }
        }
      });
      if (promises.length > 0) {
        Promise.all(promises).then(() => {
          const urls = [];
          list.forEach(urlInfo => {
            if (urlInfo.url) urls.push(urlInfo);
          });
          //console.log("urls111",urls);
          resolve(urls);
        }).catch(ex => {
          reject(ex);
        });
      } else {
        resolve([]);
      }
    } catch(ex) {
      reject(ex);
    }
  });
  return promise;
}

export function getSources() {
  const list = [];
  const aiim = Context.instance.aiim;
  const sources = (aiim && aiim.datasets && aiim.datasets.categories &&
    aiim.datasets.categories.sources) || [];
  sources.forEach(source => {
    if (source.url && source.layer2D) {
      list.push(source);
    }
  });
  return list;
}

// export function makeValidActions(actions) {
//   let valid = [];
//   actions.forEach(action => {
//     if (val.isNonEmptyStr(action.label,true) && val.isNonEmptyStr(action.url,true)) {
//       if (action.layers.length > 0 || action.categories.length > 0) {
//         let action2 = Object.assign({},action);
//         action2.label = val.trim(action.label);
//         action2.url = val.trim(action.url);
//         action2.categories = action2.categories.slice();
//         action2.layers = action2.layers.slice()
//         delete action2.uiKey;
//         valid.push(action2);
//       }
//     }
//   });
//   return valid;
// }

export function newAction() {
  let action = {
    label: null,
    url: null,
    layers: ["*"],
    categories: ["*"]
  };
  return action;
}

function nextId() {
  return "appLaunchUrl-" + COUNTER++;
}

export function three11AsAppLaunch(three11Url) {
  let appLaunch = null;
  if (typeof val.isNonEmptyStr(three11Url,true)) {
    const i18n = Context.instance.i18n;
    const action = newAction();
    Object.assign(action,{
      label: i18n.infoPanel.actions.launch311,
      url: three11Url.trim(),
      layers: ["*"],
      categories: ["*"]
    });
    appLaunch = {
      actions: [action]
    }
  }
  return appLaunch;
}
